const BASE_LANGUAGE = 'en-JM';

const FALLBACK_CHAINS: Record<string, string[]> = {
    'de-CH': ['de-DE', BASE_LANGUAGE],
    'no-NO': ['da-DK', BASE_LANGUAGE],
    'es-US': ['es-ES', BASE_LANGUAGE],
};

/**
 * i18next's `fallbackLng`: the languages it downloads and consults after `language`, nearest first.
 *
 * A language whose catalogue the build completed from its fallbacks needs none, and a chain ends at
 * the first such language. Without a language, i18next also takes the first entry as the language
 * to render an unsupported locale in.
 *
 * @param completedLanguages The languages whose catalogues this app's build completes. Empty for an
 *                           app serving Crowdin's catalogues as they are.
 */
export const runtimeFallbackLanguages =
    (completedLanguages: ReadonlySet<string>) =>
    (language: string | undefined): string[] => {
        if (language !== undefined && completedLanguages.has(language)) {
            return [];
        }
        const chain =
            language !== undefined && Object.hasOwn(FALLBACK_CHAINS, language)
                ? FALLBACK_CHAINS[language]
                : [BASE_LANGUAGE];
        const completed = chain.findIndex(fallback => completedLanguages.has(fallback));
        return completed === -1 ? chain : chain.slice(0, completed + 1);
    };
